import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useBranding } from "./branding.js";
import { FockeLogoAnimated } from "./FockeLogoAnimated.js";
import { cx } from "./util.js";
const heights = { s: "h-6", m: "h-8", l: "h-10", xl: "h-14" };
/**
 * The organization's logo (applyBranding), else `fallback` or the Focke
 * logo. An org with a logo of its own never shows the Focke logo: when its
 * image does not load, the org name stands in, or nothing.
 */
export function OrgLogo({ size, className, fallback, }) {
    const branding = useBranding();
    const [failed, setFailed] = useState(null);
    const url = branding?.logoUrl;
    if (!branding || !url)
        return _jsx(_Fragment, { children: fallback ?? _jsx(FockeLogoAnimated, { color: "currentColor" }) });
    if (failed === url)
        return branding.name ? _jsx("span", { className: "font-semibold", children: branding.name }) : _jsx(_Fragment, {});
    const img = (_jsx("img", { src: url, alt: branding.name ?? "", draggable: false, onError: () => setFailed(url), className: cx(heights[size ?? branding.logoSize ?? "m"], "w-auto max-w-[220px] object-contain", className) }));
    if (!branding.logoPlate)
        return img;
    return _jsx("span", { className: "inline-flex items-center rounded-lg bg-white px-2 py-1", children: img });
}
